<template>
  <div class="flex flex-col items-center w-[30rem]">
    <div class="flex items-center justify-center grow border border-dashed rounded-lg p-1 border-grey-625 w-full">
      <img :src="img" :alt="label" class="object-cover" />
    </div>
    <span class="mt-1 px-1 py-1v rounded-md text-center" :class="bgColorClass">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  img: string;
  label: string;
  labelBgColor?: "success" | "error" | "neutral";
}

const { img, label, labelBgColor = "neutral" } = defineProps<Props>();

const bgColorClass = computed(() => {
  switch (labelBgColor) {
    case "error":
      return "bg-error-925";
    case "success":
      return "bg-success-925";
    case "neutral":
    default:
      return "";
  }
});
</script>
